import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AddAppIcon(props) {
	return (
		<svg width={props.width ? props.width : "24"} height={props.height ? props.height : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="2" y="2" width="20" height="20" rx="8" fill={props.fill} />
			<rect x="11" y="8" width="2" height="8" rx="1" fill={props.fill2 ? props.fill2 : "white"} />
			<rect x="16" y="11" width="2" height="8" rx="1" transform="rotate(90 16 11)" fill={props.fill2 ? props.fill2 : "white"} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AddAppIcon fill={props.fill} fill2={props.fill2} width={props.width} height={props.height} />
		</div>
	);
}